import { SteppedTutorialFragment } from 'api/contentful/contentful.graphql.types'
import { Button } from 'components/button/Button'
import { ButtonProps } from 'components/button/types'
import { extractSteps } from 'components/cornerstone/CornerstoneUtils'
import { Icon } from 'components/icon'
import { Step, StepsGuideList } from 'components/stepsGuide/StepsGuide'
import { Title, Title_h3_default } from 'components/Typography'
import React, { FC, ReactNode } from 'react'
import { SAreaButton, SAreaSteps, SAreaTitle, STitledStepsGuide } from './TitledStepsGuide.styled'

export type TitledStepsGuideProps = Omit<React.ComponentProps<typeof StepsGuideList>, 'steps'> & {
  title?: string | null
  button?: ReactNode
  content?: SteppedTutorialFragment | null
  buttonProps?: Partial<ButtonProps>
  steps?: Step[]
}

const defaultButtonProps: ButtonProps = {
  variant: 'secondary',
  size: 'large',
  tone: 'dark',
  leftIcon: <Icon name="ArrowRight" />,
  type: 'button',
}

export const TitledStepsGuide: FC<React.PropsWithChildren<TitledStepsGuideProps>> = (props) => {
  const { title, button, content, steps, ...guideListProps } = props

  return (
    <STitledStepsGuide>
      <SAreaTitle>
        <Title variant={Title_h3_default}>{title ?? content?.tutorialTitle}</Title>
      </SAreaTitle>
      <SAreaButton>
        {button ?? (
          <Button
            {...defaultButtonProps}
            children={content?.buttonLabel}
            {...(props.buttonProps ?? {})}
          />
        )}
      </SAreaButton>
      <SAreaSteps>
        <StepsGuideList
          visualHeight={content?.isIcon ? 36 : 240}
          steps={steps ?? (props.content ? extractSteps(props.content) : [])}
          {...guideListProps}
        />
      </SAreaSteps>
    </STitledStepsGuide>
  )
}
